var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSort(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 5,
    height: 9,
    viewBox: "0 0 5 9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#001246",
    fillRule: "nonzero",
    d: "M2.977 7.138L4.16 5.677a.462.462 0 0 1 .672-.058c.2.178.225.494.055.704l-2.023 2.5a.463.463 0 0 1-.728 0l-2.023-2.5a.517.517 0 0 1 .055-.704.462.462 0 0 1 .672.058l1.183 1.461V.5c0-.276.214-.5.477-.5s.477.224.477.5v6.638z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSort);
export default __webpack_public_path__ + "static/media/sort.18768bb1619a6ceb4fa4fbabc4e9655a.svg";
export { ForwardRef as ReactComponent };